// src/components/Sidebar.js
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import LinkIcon from '@mui/icons-material/Link';
import ArchiveIcon from '@mui/icons-material/Archive';
import ExpireIcon from '@mui/icons-material/AccessTime';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronDownIcon from '@mui/icons-material/ExpandMore';
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openLinks, setOpenLinks] = useState(true);

  return (
    <Box sx={{
      width: 225, minHeight: "100vh", bgcolor: "#f5f7fa", py: 3, borderRight: "1.5px solid #e0e7ef",
      position: "fixed", top: 0, left: 0, zIndex: 1200
    }}>
      <Box sx={{ fontWeight: 900, fontSize: 21, color: "#6366f1", textAlign: "center", mb: 4, letterSpacing: 2 }}>
        <span style={{ color: "#facc15" }}>🔗</span> Link.<span style={{ color: "#facc15" }}>visaothe.net</span>
      </Box>
      <List>
        <ListItemButton selected={location.pathname === "/user"} onClick={() => navigate("/user")}>
          <ListItemIcon><DashboardIcon /></ListItemIcon>
          <ListItemText primary="Trang tổng quan" />
        </ListItemButton>
        <ListItemButton selected={location.pathname === "/user/stats"} onClick={() => navigate("/user/stats")}>
          <ListItemIcon><BarChartIcon /></ListItemIcon>
          <ListItemText primary="Thống kê" />
        </ListItemButton>
        <ListItemButton onClick={() => setOpenLinks(!openLinks)}>
          <ListItemIcon><LinkIcon /></ListItemIcon>
          <ListItemText primary="Quản lý liên kết" />
          {openLinks ? <ChevronDownIcon /> : <ChevronRightIcon />}
        </ListItemButton>
        <Collapse in={openLinks} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 5 }} selected={location.pathname === "/user/links"} onClick={() => navigate("/user/links")}>
              <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary="Liên kết" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 5 }} selected={location.pathname === "/user/links/archived"} onClick={() => navigate("/user/links/archived")}>
              <ListItemIcon><ArchiveIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary="Liên kết đã lưu trữ" />
            </ListItemButton>
            <ListItemButton sx={{ pl: 5 }} selected={location.pathname === "/user/links/expired"} onClick={() => navigate("/user/links/expired")}>
              <ListItemIcon><ExpireIcon fontSize="small" /></ListItemIcon>
              <ListItemText primary="Liên kết đã hết hạn" />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </Box>
  );
}
